import { Button } from 'uikit'
import { Snippets, SnippetsHeading, SnippetsItem, SnippetsList } from 'uikit'
import {
  Container,
  FilterHeader,
  FilterStack,
  SnippetsContainer,
  SnippetsContainerMain,
  SnippetsContainerRightAside,
} from 'uikit/layout'
import { HeadingItem, ItemIcon, ItemText } from 'uikit/Snippets'
import { IoDocument } from 'react-icons/io5'
import { useHistory } from 'react-router-dom'
import { useFetchBlackList } from './services/useFetchBlackList'
import { ListFilter } from './ListFilter'
import { useCallback, useRef } from 'react'
import { ROLES } from 'shared/constants/user'
import { useStore } from '@tanstack/react-store'
import { authStore } from 'shared/store/auth'
import { getAccess } from 'features/Private'
import { getDateTimeReadFormat } from 'shared/utils/dateFormatting'

export const List = () => {
  const history = useHistory()
  const { list, hasMore, fetchNextPage, isLoading, fetch } = useFetchBlackList()
  const { user } = useStore(authStore)
  const isAdmin = getAccess(user.roles, [ROLES.admin])

  const onChangeFilters = useCallback((state) => {
    const { subject } = state

    fetch({ subject })
  }, [])

  return (
    <Container>
      <SnippetsContainer indentTop={122}>
        <SnippetsContainerMain>
          <Snippets columns="42px minmax(170px, 1fr) minmax(150px, 1fr) minmax(150px, 1fr)">
            <SnippetsHeading position="sticky" top="0" zIndex={3}>
              <HeadingItem />
              <HeadingItem>Номер карты/телефона</HeadingItem>
              <HeadingItem>Комментарий </HeadingItem>
              <HeadingItem>Создан </HeadingItem>
            </SnippetsHeading>
            <SnippetsList
              data={list}
              isLoading={isLoading}
              hasMore={hasMore}
              onNext={() => fetchNextPage()}
            >
              {(item) => (
                <SnippetsItem>
                  <ItemIcon IconComponent={IoDocument} />
                  <ItemText>{item?.subject}</ItemText>
                  <ItemText>{item?.description}</ItemText>
                  <ItemText>{getDateTimeReadFormat(item?.created)}</ItemText>
                </SnippetsItem>
              )}
            </SnippetsList>
          </Snippets>
        </SnippetsContainerMain>
        <SnippetsContainerRightAside>
          <FilterHeader>
            <Button
              width="100%"
              onClick={() => history.push(`/services/black-list/new`)}
              colorPalette="orange"
              disabled={!isAdmin}
            >
              Добавить
            </Button>
          </FilterHeader>
          <FilterStack>
            <ListFilter onChange={onChangeFilters} />
          </FilterStack>
        </SnippetsContainerRightAside>
      </SnippetsContainer>
    </Container>
  )
}
